import { render, staticRenderFns } from "./GradeDetailed.vue?vue&type=template&id=8f412f96&scoped=true&"
import script from "./GradeDetailed.vue?vue&type=script&lang=js&"
export * from "./GradeDetailed.vue?vue&type=script&lang=js&"
import style0 from "./GradeDetailed.vue?vue&type=style&index=0&id=8f412f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f412f96",
  null
  
)

export default component.exports